module.exports = __webpack_public_path__ + "common/sidebar/icon-category-0a4ac66c5887680f5adba5cdce79f067.svg";